import React from 'react'

import Icon from 'components/elements/Icon'

import { useActionless, useAppSelector } from 'app-redux/hooks'
import { SET_COLLECTION_V2_STATE } from 'app-redux/collectionV2/actions/types'
import { ImageSize } from 'app-redux/cacheables/initialState'

import styles from './imageSizeControls.module.scss'

type Props = {
  imageSize: ImageSize
  onChange: (imageSize: ImageSize) => void
  className?: string
}

const ImageSizeControls = ({ imageSize, onChange, className = '' }: Props) => {
  const handleChangeImageSize = (updatedImageSize: ImageSize) => onChange(updatedImageSize)

  const handleMakeSmaller = () => {
    if (imageSize === 2) return handleChangeImageSize(1)
    if (imageSize === 3) return handleChangeImageSize(2)

    return handleChangeImageSize(1)
  }

  const handleMakeLarger = () => {
    if (imageSize === 2) return handleChangeImageSize(3)
    if (imageSize === 1) return handleChangeImageSize(2)

    return handleChangeImageSize(3)
  }

  return (
    <div className={`${styles.sizeSelector} ${className}`}>
      <button type="button" onClick={handleMakeSmaller} className={`${styles.indicator} ${styles.smaller}`}>
        <Icon name="image outline" />
      </button>
      <div className={styles.options}>
        <button type="button" disabled={imageSize === 1} onClick={() => handleChangeImageSize(1)}>
          <Icon name={imageSize === 1 ? 'circle' : 'circle outline'} />
        </button>
        <button type="button" disabled={imageSize === 2} onClick={() => handleChangeImageSize(2)}>
          <Icon name={imageSize === 2 ? 'circle' : 'circle outline'} />
        </button>
        <button type="button" disabled={imageSize === 3} onClick={() => handleChangeImageSize(3)}>
          <Icon name={imageSize === 3 ? 'circle' : 'circle outline'} />
        </button>
      </div>
      <button type="button" onClick={handleMakeLarger} className={`${styles.indicator} ${styles.larger}`}>
        <Icon name="image outline" />
      </button>
    </div>
  )
}

export default ImageSizeControls

export const CollectionImageSizeControls = () => {
  const imageSize = useAppSelector(state => state.collectionV2.imageSize)

  const [setCollectionV2State] = useActionless(SET_COLLECTION_V2_STATE)

  const handleChangeImageSize = (imageSize: ImageSize) => setCollectionV2State({ imageSize })

  return <ImageSizeControls imageSize={imageSize} onChange={handleChangeImageSize} />
}
